'use client'

import { useRef, useState } from "react"
import styles from './ua.module.scss'
import Button from "../button/Button"
import Dropdown from "../dropdown/Dropdown"
import Form from "../form/Form"
import Icon from "../icon/Icon"
import StackedPanel from "../panel/StackedPanel"
import PanelBody from "../panel/PanelBody"
import PanelFooter from "../panel/PanelFooter"
import { genInvUrl, getFiltersFromParams } from "@/data/Inventory"
import { useRouter } from "next/navigation"

export default function ColorButton(props) {
  
  const [selected,setSelected] = useState(props.filters.color || [])
  
  const ddColors = useRef()
  const router = useRouter()
  
  const colors = [
    { value: 'White', label: 'White', color: '#ebebeb' },
    { value: 'Black', label: 'Black', color: '#000000' },
    { value: 'Blue', label: 'Blue', color: '#03398f' },
    { value: 'Silver', label: 'Silver', color: '#bfbfbf' },
    { value: 'Gray', label: 'Gray', color: '#474747' },
    { value: 'Red', label: 'Red', color: '#7a0707' },
    { value: 'Beige', label: 'Beige', color: '#b58112' },
    { value: 'Green', label: 'Green', color: '#077d05' },
    { value: 'Yellow', label: 'Yellow', color: '#c4b012' },
    { value: 'Brown', label: 'Brown', color: '#6e4d08' },
  ]
  
  const toggle = (e) => {
    if(e) e.preventDefault()
    ddColors.current.toggle()
  }
  
  const isSelected = (color) => {
    return selected.indexOf(color) >= 0
  }

  const select = (e, color) => {
    let values = [...selected]
    const i = values.indexOf(color.value)
    if (i >= 0) {
      values.splice(i, 1)
    } else {
      values.push(color.value)
    }
    setSelected(values)
  }

  const clear = (e) => {
    setSelected([])
    props.listingRef.current.applyFilters({ color: [], clear: true })
    toggle(e)
  }
  
  const onSubmit = (e, values) => {
    toggle(e)
    let urlParams = Object.assign(getFiltersFromParams(props), props.filters || {})
    urlParams.color = selected.join(",")
    const url = genInvUrl(urlParams, {})
    router.push(url)
  }

  return <>
    <Button theme={["filter-icon", "filter-icon-wide", (selected.length > 0 ? 'filter-on' : '')]} onClick={e => toggle(e) } label={"Filter by Color"}>
      <Icon {...props} name="colors"></Icon>
      <span>{ 'Color' }</span>
    </Button>
    <Dropdown {...props} key="colors" ref={ddColors} position={'left'} body={'padded'} offset={'12px'} title="Filter by Color">
      <Form id="filter_color_picker" name="Color Picker" onSubmit={e => onSubmit(e)}>
        <StackedPanel>
          <PanelBody padded={true}>
            <div className="flex-column flex-with-gap">
              <div className="flex-col">Exterior Color</div>
              <div className="flex-col">
                <div className={styles.cls}>
                  { colors.map(c => (
                    <div key={c.value} className="flex-col">
                      <Button theme="base" noLabel={true} label={c.label} className={ isSelected(c.value) ? styles.clssel : '' } onClick={e => select(e, c)} style={{ background: c.color }}></Button>
                      <div className={ styles.clslbl }>{ c.label }</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </PanelBody>
          <PanelFooter>
            <div className="flex-row flex-with-gap flex-full">
              <div className="flex-col flex-stretch flex-col50">
                <Button theme={'secondary'} label="Apply Filters"></Button>
              </div>
              <div className="flex-col flex-stretch flex-col50">
                <Button theme={'gray-light'} disabled={selected.length == 0} label="Clear" onClick={e => clear()}></Button>
              </div>
            </div>
          </PanelFooter>
        </StackedPanel>
      </Form>
    </Dropdown>
  </>
  
}